/**
 * Blog Hub 前端分页
 *
 * 合并多个博客的文章后无法使用 Liquid 的 paginate（paginate 只支持 collection / blog 原生集合），
 * 所以服务端一次性输出全部卡片，这里负责分页展示：
 *   - 未启用 JS 或脚本未加载时，所有文章保持可见（渐进增强，不影响 SEO 抓取）
 *   - 分页按钮生成成功后才隐藏超出的卡片，避免脚本异常导致内容丢失
 *   - 支持主题编辑器里动态加载 section（shopify:section:load）
 */
(function () {
  var HUB_SELECTOR = '[data-blog-hub]';
  var GRID_SELECTOR = '[data-blog-hub-grid]';
  var CARD_SELECTOR = '[data-blog-hub-card]';
  var PAGINATION_SELECTOR = '[data-blog-hub-pagination]';
  var STICKY_BAR_SELECTOR = '.shopify-section--header, .shopify-section--announcement-bar';
  var MAX_PAGE_BUTTONS = 7;

  /**
   * 主题的 header / announcement-bar 自身是 position: sticky，
   * 翻页后滚动定位需要减掉它们的高度，否则标题会被压住。
   */
  function getStickyHeaderOffset() {
    var offset = 0;

    document.querySelectorAll(STICKY_BAR_SELECTOR).forEach(function (element) {
      var position = window.getComputedStyle(element).position;
      if (position !== 'fixed' && position !== 'sticky') return;

      var rect = element.getBoundingClientRect();
      if (rect.top <= 1 && rect.height > 0) offset += rect.height;
    });

    return offset;
  }

  function announce(message) {
    var region = document.getElementById('status-announcement');
    if (region) region.textContent = message;
  }

  function buildPageList(currentPage, totalPages) {
    var pages = [];

    if (totalPages <= MAX_PAGE_BUTTONS) {
      for (var i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    pages.push(1);

    var start = Math.max(2, currentPage - 1);
    var end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) pages.push('gap');
    for (var j = start; j <= end; j++) pages.push(j);
    if (end < totalPages - 1) pages.push('gap');

    pages.push(totalPages);
    return pages;
  }

  function createButton(options) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'seo-blog-hub-pagination__button';
    button.textContent = options.label;
    button.dataset.page = options.page;
    button.setAttribute('aria-label', options.ariaLabel);

    if (options.direction) {
      button.classList.add('seo-blog-hub-pagination__button--direction');
      button.disabled = options.disabled;
    }

    if (options.current) {
      button.setAttribute('aria-current', 'page');
    }

    return button;
  }

  function initHub(hub) {
    if (hub.dataset.blogHubReady === 'true') return;

    var grid = hub.querySelector(GRID_SELECTOR);
    var pagination = hub.querySelector(PAGINATION_SELECTOR);
    if (!grid || !pagination) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll(CARD_SELECTOR));
    var pageSize = parseInt(grid.dataset.pageSize, 10);
    if (!pageSize || pageSize < 1) pageSize = 9;

    var totalPages = Math.ceil(cards.length / pageSize);
    if (cards.length <= pageSize || totalPages < 2) return;

    var label = pagination.getAttribute('aria-label') || 'Latest articles pagination';
    var currentPage = 1;

    function render() {
      var start = (currentPage - 1) * pageSize;
      var end = start + pageSize;

      for (var i = 0; i < cards.length; i++) {
        cards[i].hidden = i < start || i >= end;
      }

      var pages = document.createElement('div');
      pages.className = 'seo-blog-hub-pagination__pages';

      var prev = createButton({
        label: '‹',
        page: currentPage - 1,
        ariaLabel: 'Previous page',
        direction: true,
        disabled: currentPage === 1
      });

      pagination.replaceChildren(prev);

      buildPageList(currentPage, totalPages).forEach(function (page) {
        if (page === 'gap') {
          var gap = document.createElement('span');
          gap.className = 'seo-blog-hub-pagination__ellipsis';
          gap.textContent = '…';
          gap.setAttribute('aria-hidden', 'true');
          pages.appendChild(gap);
          return;
        }

        pages.appendChild(
          createButton({
            label: String(page),
            page: page,
            ariaLabel: 'Page ' + page,
            current: page === currentPage
          })
        );
      });

      var next = createButton({
        label: '›',
        page: currentPage + 1,
        ariaLabel: 'Next page',
        direction: true,
        disabled: currentPage === totalPages
      });

      pagination.appendChild(pages);
      pagination.appendChild(next);

      var status = document.createElement('p');
      status.className = 'seo-blog-hub-pagination__status';
      status.textContent = 'Page ' + currentPage + ' of ' + totalPages;
      pagination.appendChild(status);
    }

    function goTo(page) {
      if (page < 1 || page > totalPages || page === currentPage) return;
      currentPage = page;
      render();

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = grid.getBoundingClientRect().top + window.scrollY - getStickyHeaderOffset() - 24;

      window.scrollTo({
        top: top > 0 ? top : 0,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });

      announce('Page ' + currentPage + ' of ' + totalPages);
    }

    pagination.setAttribute('aria-label', label);
    pagination.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var button = target.closest('button[data-page]');
      if (!button || button.disabled) return;

      goTo(parseInt(button.dataset.page, 10));
    });

    try {
      render();
    } catch (error) {
      // 生成失败时保持全部卡片可见
      for (var i = 0; i < cards.length; i++) cards[i].hidden = false;
      pagination.hidden = true;
      return;
    }

    pagination.hidden = false;
    hub.dataset.blogHubReady = 'true';
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var hubs = Array.prototype.slice.call(root.querySelectorAll(HUB_SELECTOR));

    if (root.matches && root.matches(HUB_SELECTOR)) hubs.push(root);

    for (var i = 0; i < hubs.length; i++) initHub(hubs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
